import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';

import { useFnol } from '../../context';
import formatDate from '../../utils/formatDate';
import fnolServices from '../../services/fnolServices';
import ErrorMessage from '../../components/ErrorMessage';
import {
  InputField,
  InputContainer,
  PrimaryButton,
  SecondaryButton,
} from '../../components';

import {
  STEP_ANSWER_QUESTIONS,
  STEP_SELECT_FNOL_TEMPLATE,
} from '../../CONSTANTS';

import ButtonWrapper from '../../components/ButtonWrapper';

const IndentifyCustomerView = () => {
  const {
    customerInformation,
    incidentDay,
    selectedFnolTemplate,
    setFnolTemplate,
    setIncidentDay,
    setInsuredObject,
    setInsuranceHolder,
    setSelectedFnolTemplate,
    setStep,
  } = useFnol();

  const { t } = useTranslation();

  const [state, setState] = useState({
    incidentDate: null,
    insuranceHolder: '',
    insuredObject: '',
  });

  const [hasError, setHasErrors] = useState({
    insuredObject: false,
    insuraceHolder: false,
    incidentDay: false,
  });

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  useEffect(() => {
    setState((state) => ({
      ...state,
      insuredObject: customerInformation.insuredObject,
      insuranceHolder: customerInformation.insuranceHolder,
      incidentDate: incidentDay,
    }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState((state) => ({
      ...state,
      [name]:
        selectedFnolTemplate.category.insuredObjectQuery.tag === 'Vehicle'
          ? value.toUpperCase()
          : value,
    }));
  };

  const handleChangeIncidentDay = (date) =>
    setState((state) => ({
      ...state,
      incidentDate: date,
    }));

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  const handleGoBackClick = () => {
    setSelectedFnolTemplate(null);
    setStep(STEP_SELECT_FNOL_TEMPLATE);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fnolServices.initiate(selectedFnolTemplate.name);
    const fnolKey = response.data.fnolKey;

    if (
      selectedFnolTemplate.category.insuredObjectQuery.tag === 'Address' ||
      selectedFnolTemplate.category.insuredObjectQuery.tag === 'Product'
    ) {
      try {
        await fnolServices.setInsuranceHolder(fnolKey, {
          insuranceHolder: {
            tag: selectedFnolTemplate.category.insuranceHolderQuery.tag,
            contents: state.insuranceHolder,
          },
        });

        setHasErrors((state) => ({
          ...state,
          insuraceHolder: false,
        }));
      } catch (error) {
        setHasErrors((state) => ({
          ...state,
          insuraceHolder: true,
        }));

        return;
      }
    }

    try {
      await fnolServices.setInsuredObject(fnolKey, {
        insuredObject: {
          tag: selectedFnolTemplate.category.insuredObjectQuery.tag,
          contents: state.insuredObject,
        },
      });

      setHasErrors((state) => ({
        ...state,
        insuredObject: false,
      }));
    } catch (error) {
      setHasErrors((state) => ({
        ...state,
        insuredObject: true,
      }));

      return;
    }

    if (state.incidentDate) {
      await fnolServices.setIncidentDay(
        fnolKey,
        formatDate(state.incidentDate)
      );

      setHasErrors((state) => ({
        ...state,
        incidentDay: false,
      }));
    } else {
      setHasErrors((state) => ({
        ...state,
        incidentDay: true,
      }));

      return;
    }

    setIncidentDay(state.incidentDate);
    setInsuredObject(state.insuredObject);
    if (
      selectedFnolTemplate.category.insuredObjectQuery.tag === 'Address' ||
      selectedFnolTemplate.category.insuredObjectQuery.tag === 'Product'
    ) {
      setInsuranceHolder(state.insuranceHolder);
    }

    setFnolTemplate(response.data);
    setStep(STEP_ANSWER_QUESTIONS);
  };

  return (
    <form onSubmit={handleSubmit}>
      {(selectedFnolTemplate.category.insuredObjectQuery.tag === 'Address' ||
        selectedFnolTemplate.category.insuredObjectQuery.tag === 'Product') && (
        <InputContainer hasError={hasError.insuraceHolder}>
          <label>
            {selectedFnolTemplate.category.insuranceHolderQuery.contents}
          </label>
          <InputField
            name='insuranceHolder'
            value={state.insuranceHolder}
            onChange={handleChange}
            placeholder={t(
              `identifyCustomer.insuranceHolder.${selectedFnolTemplate.category.insuranceHolderQuery.tag}.placeholder`
            )}
          />
          {hasError.insuraceHolder && (
            <ErrorMessage>
              {t(
                `identifyCustomer.insuranceHolder.${selectedFnolTemplate.category.insuranceHolderQuery.tag}.errorMessage`
              )}
            </ErrorMessage>
          )}
        </InputContainer>
      )}
      <InputContainer hasError={hasError.insuredObject}>
        <label>
          {selectedFnolTemplate.category.insuredObjectQuery.contents}
        </label>
        <InputField
          name='insuredObject'
          value={state.insuredObject}
          onChange={handleChange}
          placeholder={t(
            `identifyCustomer.insuredObject.${selectedFnolTemplate.category.insuredObjectQuery.tag}.placeholder`
          )}
        />
        {hasError.insuredObject && (
          <ErrorMessage>
            {t(
              `identifyCustomer.insuredObject.${selectedFnolTemplate.category.insuredObjectQuery.tag}.errorMessage`
            )}
          </ErrorMessage>
        )}
      </InputContainer>
      <InputContainer hasError={hasError.incidentDay}>
        <label>{selectedFnolTemplate.category.incidentDayQuery}</label>
        <DatePicker
          locale={t('calendarLocale')}
          dateFormat={t('calendarDateFormat')}
          selected={state.incidentDate}
          maxDate={new Date()}
          onChange={(date) => handleChangeIncidentDay(date)}
          onChangeRaw={handleDateChangeRaw}
        />
        {hasError.incidentDay && (
          <ErrorMessage>{t(`identifyCustomer.incidentDate`)}</ErrorMessage>
        )}
      </InputContainer>
      <ButtonWrapper>
        <>
          <SecondaryButton onClick={handleGoBackClick}>
            {t('buttons.back')}
          </SecondaryButton>
          <PrimaryButton type='submit'>{t('buttons.continue')}</PrimaryButton>
        </>
      </ButtonWrapper>
    </form>
  );
};

export default IndentifyCustomerView;
